import { render } from "./footer-component.vue?vue&type=template&id=b3f95abc&scoped=true"
import script from "./footer-component.vue?vue&type=script&lang=js"
export * from "./footer-component.vue?vue&type=script&lang=js"

import "./footer-component.vue?vue&type=style&index=0&id=b3f95abc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f95abc"]])

export default __exports__